import React from 'react';
import '../CSS/Home.css';
import CoinsContainer from '../components/CoinsContainer';

const Home = () => (
  <>
    <div className="home-wrap">
      <h2>Track Your Coin Know How&apos;s They Doing !</h2>
    </div>
    <CoinsContainer />
  </>
);

export default Home;
